/**
 * Converte uma string de data no formato "DD/MM/YYYY" para o formato ISO 8601 "YYYY-MM-DD"
 * @param {*} dateStr - String de data no formato "DD/MM/YYYY"
 * @returns Data no formato ISO 8601 "YYYY-MM-DD"
 */
export default function convertToISODate(dateStr) {
  if (!dateStr) return "";
  const [day, month, year] = dateStr.split("/");
  if (!day || !month || !year) return "";
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
}
